import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import es from 'vuetify/lib/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#1E3E52',
        secondary: '#B1D3E9',
        accent: '#083054',
        success: '#A5D983',
        error: '#FC7D66',
        warning: '#FFDE60',
        sand: '#F4F4F4',
        silver: '#B5BEC4',
        info: '#B1D3E9'
      }
    }
  }
})
